// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3zmnO","legacyBtn":"MutateMid_legacyBtn__3Ph4V"};